// @flow
import { CHANGE_TITLE, CHANGE_DESCRIPTION } from './constants';
import type { Action, LocalizedValue } from './types';

export const changeTitle = (localizedTitle: LocalizedValue): Action => ({
  type: CHANGE_TITLE,
  localizedValue: localizedTitle
});

export const changeDescription = (localizedDescription: LocalizedValue): Action => ({
  type: CHANGE_DESCRIPTION,
  localizedValue: localizedDescription
});
